<div class="col-xl-6 mx-auto">
  <app-video [data]="media" large="true"></app-video>
</div>
  
